import React, { useRef } from 'react';
import './FormatEditor.scss';
import { Column, Grid } from '../../../../FormComponents/Grid/Grid';
import { Format } from '../../../../../types/Glossary';
import Help from '../../../../Help/Help';

type Props = {
  data: Format[];
  setData: React.Dispatch<React.SetStateAction<Format[]>>;
  setIsDirty: React.Dispatch<React.SetStateAction<boolean>>;
};

export const FormatEditor = (props: Props) => {
  const gridRef = useRef<HTMLDivElement>(null);

  const columns: Column<Format>[] = [
    { key: "phrase", label: "Word/Phrase", type: "text" }
  ];

  return (
    <>
      <div ref={gridRef} className="format-editor">
        <p>Used to highlight or normalize specific terms (e.g. brand names, acronyms, technical terms).
        <Help
          title="📘 Text Formatting"
          text={`<br/><b>Purpose:</b> Used to highlight or normalize specific terms (e.g., brand names, acronyms, technical terms).<br/><br/><b>Description:</b> Matching is case-insensitive and punctuation-safe, so terms are replaced without removing surrounding punctuation. Only exact word matches are replaced, words that contain the term as part of another word remain unchanged. Rules are applied in the order they appear in the list.<br/><br/><b>Example:</b><br/>Glossary term → AccessLoop<br/>Result:<br/>"AccessLoop!" → "AccessLoop"<br/>"accessloop." → "AccessLoop"<br/>"ACCESSLOOP" → "AccessLoop"<br/><br/><b>General Notes:</b><br/>Punctuation such as . , ! ? ; : is preserved.<br/>Designed to standardize terminology and ensure consistency across text.`}
          maxWidth='660px'
        /></p>
        <Grid<Format>
          columns={columns}
          data={props.data}
          setData={props.setData}
          setIsDirty={props.setIsDirty}
          maxHeight={220} />
      </div>
    </>
  );
};
